import { useEffect, useMemo, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const unique = items => {
  const seen = new Set();
  return items.filter(i => {
    if (!i.value || seen.has(i.value)) return false;
    seen.add(i.value);
    return true;
  });
};

// Pass an ID to filter to one destination, or nothing/null to get all rows
export const useGetCustomerWeighbridgeDetails = (destinationSiteAssessmentID = null) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');

    customAxios
      .post(
        '/Ops/GetCustomerWeighbridgeDetails',
        {
          destinationSiteAssessmentID: destinationSiteAssessmentID || null,
          weighbridgeSiteAssessmentID: null,
          custCode: null,
        },
        { headers: authHeader() },
      )
      .then(res => {
        if (!cancelled) setRows(Array.isArray(res.data) ? res.data : []);
      })
      .catch(e => {
        if (!cancelled) {
          setRows([]);
          setError(e?.response?.data?.message || e.message || 'Failed to load customers/weighbridges');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [destinationSiteAssessmentID]);

  const destinations = useMemo(
    () =>
      unique(
        rows.map(r => ({
          label: r.destinationName?.trim(),
          value: r.destinationName?.trim(),
          destinationSiteAssessmentID: r.destinationSiteAssessmentID,
        })),
      ),
    [rows],
  );

  const weighbridges = useMemo(
    () =>
      unique(
        rows.map(r => ({
          label: r.weighbridgeName?.trim(),
          value: r.weighbridgeName?.trim(),
          weighbridgeSiteAssessmentID: r.weighbridgeSiteAssessmentID,
        })),
      ),
    [rows],
  );

  const customers = useMemo(
    () =>
      unique(
        rows.map(r => ({
          label: r.customerName?.trim(),
          value: r.customerName?.trim(),
          custCode: r.custCode,
        })),
      ),
    [rows],
  );

  return { rows, destinations, weighbridges, customers, loading, error };
};